/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */
import {
  useMutation,
  useQuery,
  type DataTag,
  type MutationFunction,
  type QueryClient,
  type QueryFunction,
  type QueryKey,
  type UseMutationOptions,
  type UseMutationReturnType,
  type UseQueryOptions,
  type UseQueryReturnType,
} from "@tanstack/vue-query"
import { computed, toValue, unref, type MaybeRefOrGetter } from "vue"

import { customInstance, type ErrorType } from ".././client.ts"
import { useMutationOptions } from ".././mutationOptions.ts"
import { useQueryOptions } from ".././queryOptions.ts"
import type {
  Error,
  GetCustomerResponse,
  GetSmartMeterReadingFrequencyResponse,
  UpdateCustomerRequest,
  UpdateSmartMeterReadingFrequencyRequest,
} from "../model"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Get current customer information
 */
export const getCustomer = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetCustomerResponse>(
    { url: `/api/v1/customers/me`, method: "GET", signal },
    options,
  )
}

export const getGetCustomerQueryKey = () => {
  return ["api", "v1", "customers", "me"] as const
}

export const useGetCustomerQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomer>>,
  TError = ErrorType<Error>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>
  >
  request?: SecondParameter<typeof customInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetCustomerQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomer>>> = ({
    signal,
  }) => getCustomer(requestOptions, signal)

  const customOptions = useQueryOptions(
    { queryKey, queryFn, ...queryOptions },
    {},
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomer>>,
    TError,
    TData
  >
}

export type GetCustomerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomer>>
>
export type GetCustomerQueryError = ErrorType<Error>

/**
 * @summary Get current customer information
 */

export function useGetCustomer<
  TData = Awaited<ReturnType<typeof getCustomer>>,
  TError = ErrorType<Error>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetCustomerQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * @summary Update customer information
 */
export const updateCustomer = (
  customerId: MaybeRefOrGetter<number>,
  updateCustomerRequest: MaybeRefOrGetter<UpdateCustomerRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  customerId = toValue(customerId)
  updateCustomerRequest = toValue(updateCustomerRequest)

  return customInstance<GetCustomerResponse>(
    {
      url: `/api/v1/customers/${customerId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateCustomerRequest,
      signal,
    },
    options,
  )
}

export const useUpdateCustomerMutationOptions = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCustomer>>,
    TError,
    { customerId: number; data: UpdateCustomerRequest },
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCustomer>>,
  TError,
  { customerId: number; data: UpdateCustomerRequest },
  TContext
> => {
  const mutationKey = ["updateCustomer"]
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCustomer>>,
    { customerId: number; data: UpdateCustomerRequest }
  > = (props) => {
    const { customerId, data } = props ?? {}

    return updateCustomer(customerId, data, requestOptions)
  }

  const customOptions = useMutationOptions({ ...mutationOptions, mutationFn })

  return customOptions
}

export type UpdateCustomerMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCustomer>>
>
export type UpdateCustomerMutationBody = UpdateCustomerRequest
export type UpdateCustomerMutationError = ErrorType<Error>

/**
 * @summary Update customer information
 */
export const useUpdateCustomer = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCustomer>>,
      TError,
      { customerId: number; data: UpdateCustomerRequest },
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof updateCustomer>>,
  TError,
  { customerId: number; data: UpdateCustomerRequest },
  TContext
> => {
  return useMutation(useUpdateCustomerMutationOptions(options), queryClient)
}
/**
 * @summary Get smart meter reading frequency for customer
 */
export const getSmartMeterReadingFrequency = (
  customerId: MaybeRefOrGetter<number>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  customerId = toValue(customerId)

  return customInstance<GetSmartMeterReadingFrequencyResponse>(
    {
      url: `/api/v1/customers/${customerId}/smartMeterReadingFrequency`,
      method: "GET",
      signal,
    },
    options,
  )
}

export const getGetSmartMeterReadingFrequencyQueryKey = (
  customerId: MaybeRefOrGetter<number>,
) => {
  return [
    "api",
    "v1",
    "customers",
    customerId,
    "smartMeterReadingFrequency",
  ] as const
}

export const useGetSmartMeterReadingFrequencyQueryOptions = <
  TData = Awaited<ReturnType<typeof getSmartMeterReadingFrequency>>,
  TError = ErrorType<Error>,
>(
  customerId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSmartMeterReadingFrequency>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetSmartMeterReadingFrequencyQueryKey(customerId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSmartMeterReadingFrequency>>
  > = ({ signal }) =>
    getSmartMeterReadingFrequency(customerId, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () => toValue(customerId) !== null && toValue(customerId) !== undefined,
      ),
      ...queryOptions,
    },
    { customerId },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getSmartMeterReadingFrequency>>,
    TError,
    TData
  >
}

export type GetSmartMeterReadingFrequencyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSmartMeterReadingFrequency>>
>
export type GetSmartMeterReadingFrequencyQueryError = ErrorType<Error>

/**
 * @summary Get smart meter reading frequency for customer
 */

export function useGetSmartMeterReadingFrequency<
  TData = Awaited<ReturnType<typeof getSmartMeterReadingFrequency>>,
  TError = ErrorType<Error>,
>(
  customerId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSmartMeterReadingFrequency>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetSmartMeterReadingFrequencyQueryOptions(
    customerId,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * @summary Update smart meter reading frequency for customer
 */
export const updateSmartMeterReadingFrequency = (
  customerId: MaybeRefOrGetter<number>,
  updateSmartMeterReadingFrequencyRequest: MaybeRefOrGetter<UpdateSmartMeterReadingFrequencyRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  customerId = toValue(customerId)
  updateSmartMeterReadingFrequencyRequest = toValue(
    updateSmartMeterReadingFrequencyRequest,
  )

  return customInstance<void>(
    {
      url: `/api/v1/customers/${customerId}/smartMeterReadingFrequency`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: updateSmartMeterReadingFrequencyRequest,
      signal,
    },
    options,
  )
}

export const useUpdateSmartMeterReadingFrequencyMutationOptions = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSmartMeterReadingFrequency>>,
    TError,
    { customerId: number; data: UpdateSmartMeterReadingFrequencyRequest },
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSmartMeterReadingFrequency>>,
  TError,
  { customerId: number; data: UpdateSmartMeterReadingFrequencyRequest },
  TContext
> => {
  const mutationKey = ["updateSmartMeterReadingFrequency"]
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSmartMeterReadingFrequency>>,
    { customerId: number; data: UpdateSmartMeterReadingFrequencyRequest }
  > = (props) => {
    const { customerId, data } = props ?? {}

    return updateSmartMeterReadingFrequency(customerId, data, requestOptions)
  }

  const customOptions = useMutationOptions({ ...mutationOptions, mutationFn })

  return customOptions
}

export type UpdateSmartMeterReadingFrequencyMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSmartMeterReadingFrequency>>
>
export type UpdateSmartMeterReadingFrequencyMutationBody =
  UpdateSmartMeterReadingFrequencyRequest
export type UpdateSmartMeterReadingFrequencyMutationError = ErrorType<Error>

/**
 * @summary Update smart meter reading frequency for customer
 */
export const useUpdateSmartMeterReadingFrequency = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSmartMeterReadingFrequency>>,
      TError,
      { customerId: number; data: UpdateSmartMeterReadingFrequencyRequest },
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof updateSmartMeterReadingFrequency>>,
  TError,
  { customerId: number; data: UpdateSmartMeterReadingFrequencyRequest },
  TContext
> => {
  return useMutation(
    useUpdateSmartMeterReadingFrequencyMutationOptions(options),
    queryClient,
  )
}
